"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var picker_emoji_1 = require("../../../component/picker-emoji");
var EmojiUtil = /** @class */ (function () {
    function EmojiUtil(editor, props) {
        var _this = this;
        if (props === void 0) { props = {}; }
        this.name = 'emoji';
        this.getRef = function (btnDOM) {
            if (!btnDOM)
                return;
            var dom = document.createElement('div');
            var extraDom = (react_1.default.createElement(picker_emoji_1.EmojiPicker, { mountDOM: btnDOM, backgroundImageFn: _this.props.backgroundImageFn, editor: _this.editor }));
            btnDOM.appendChild(dom);
            react_dom_1.default.render(extraDom, dom);
        };
        this.handler = function () { };
        this.editor = editor;
        this.props = props;
    }
    return EmojiUtil;
}());
exports.EmojiUtil = EmojiUtil;
//# sourceMappingURL=emoji-util.js.map